export default class LocalLogRecord {

    public message: string;
    public messageDate: Date;

}


// WEBPACK FOOTER //
// ./src/logging/LocalLogRecord.ts